module.exports = __webpack_public_path__ + "static/img/gift-box-rewards.7d07553.png";